import { reactive } from 'vue'
import { getSupervisorActionDefinition } from './action-registry'
import type { SupervisedActionRequest, SupervisedActionResponse, SupervisorActionDefinition } from './types'

interface PendingApprovalState {
  visible: boolean
  request: SupervisedActionRequest | null
  definition: SupervisorActionDefinition | null
  resolve: ((response: SupervisedActionResponse) => void) | null
}

const pendingApprovalState = reactive<PendingApprovalState>({
  visible: false,
  request: null,
  definition: null,
  resolve: null
})

export function useSupervisorApprovalState() {
  return pendingApprovalState
}

export function requestSupervisorApproval(request: SupervisedActionRequest): Promise<SupervisedActionResponse> {
  const definition = getSupervisorActionDefinition(request.action)

  return new Promise((resolve) => {
    pendingApprovalState.visible = true
    pendingApprovalState.request = request
    pendingApprovalState.definition = definition
    pendingApprovalState.resolve = resolve
  })
}

export function resolveSupervisorApproval(response: SupervisedActionResponse) {
  pendingApprovalState.visible = false
  pendingApprovalState.request = null
  pendingApprovalState.definition = null

  const resolver = pendingApprovalState.resolve
  pendingApprovalState.resolve = null
  resolver?.(response)
}
